export const blindBoxThemes = [
  {
    id: "sweet",
    name: "甜心治愈盒",
    icon: "ri-heart-3-line",
    desc: "以曲奇、软糖、巧克力为主线，甜度整体偏低，适合下午茶和加班间隙快速回血。",
    itemCount: 9,
    price: "¥49",
    tags: ["曲奇", "软糖", "巧克力"],
  },
  {
    id: "savory",
    name: "咸香下饭盒",
    icon: "ri-restaurant-2-line",
    desc: "咸口零食占比更高，咸蛋黄酥、肉松卷与海苔脆片一应俱全，配粥配饭都不违和。",
    itemCount: 8,
    price: "¥52",
    tags: ["咸蛋黄", "肉松", "海苔"],
  },
  {
    id: "spicy",
    name: "麻辣挑战盒",
    icon: "ri-fire-line",
    desc: "为喜欢重口味的人准备，锅巴、魔芋爽与辣味薯片分档排列，可以按承受度自选。",
    itemCount: 7,
    price: "¥55",
    tags: ["锅巴", "魔芋", "薯片"],
  },
  {
    id: "retro",
    name: "怀旧时光盒",
    icon: "ri-time-line",
    desc: "麦丽素、话梅糖、无花果丝等老味道按复古包装重新组合，一盒回到放学后的小卖部。",
    itemCount: 10,
    price: "¥46",
    tags: ["麦丽素", "话梅", "果丝"],
  },
  {
    id: "nut",
    name: "坚果能量盒",
    icon: "ri-plant-line",
    desc: "杏仁、腰果、夏威夷果与混合坚果独立小包，控制分量不浪费，适合放在工位抽屉。",
    itemCount: 6,
    price: "¥59",
    tags: ["杏仁", "腰果", "混合装"],
  },
  {
    id: "world",
    name: "世界风味盒",
    icon: "ri-earth-line",
    desc: "把不同地区的代表性小零食装进同一盒，咸甜酸辣都有，适合想一次尝个遍的尝鲜党。",
    itemCount: 11,
    price: "¥66",
    tags: ["多国", "尝鲜", "混搭"],
  },
];